<input nz-input placeholder="Meklēt" type="text" class="mb-2" [(ngModel)]="searchText" (ngModelChange)="searchAddress()" />
<nz-table #permissionsTable nzSize="small" [nzData]="filteredAddresses" [nzFrontPagination]="false" [nzScroll]="{ y: '40rem' }">
  <tbody>
    @for (address of filteredAddresses; track $index) {
      <tr>
        <td class="pointer" (click)="selectAddress(address)">{{ address.fullAddress }}</td>
      </tr>
    }
  </tbody>
</nz-table>
<div *nzModalFooter>
  <button nz-button nzType="default" (click)="cancel()">Atcelt</button>
</div>
